import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import GoogleTrustIndex from "components/GoogleTrustIndex";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieInWeekend/sections/sections/HeroSection";
import ArticleContent from "pages/Servicii/ServiciiSpeciale/CuratenieInWeekend/sections/sections/ArticleContent";

function CuratenieInWeekend() {
    return (
        <>
            <Helmet>
                <title>Curățenie în weekend pentru firme | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Servicii profesionale de curățenie în weekend pentru birouri și spații comerciale, programate astfel încât să nu întrerupă activitatea companiei."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatenie-in-weekend/" />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                    {
                    "@type": "Question",
                    "name": "Curățenia în weekend este disponibilă pentru orice tip de firmă?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Depinde de tipul spațiului, de operațiunile necesare, de acces și de disponibilitatea echipei. Intervenția potrivită se stabilește după o evaluare a locației, nu automat pentru orice interval."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Ce intervale pot fi programate în weekend?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nu promitem automat orice zi sau oră. Doral confirmă intervalul potrivit în funcție de programul locației, de tipul lucrării și de disponibilitatea echipei."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Se poate face curățenie când sediul este gol?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Poate fi o opțiune, dacă modalitatea de acces și responsabilitățile sunt stabilite în prealabil. Procedura concretă privind accesul se convine pentru fiecare proiect."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Ce servicii pot fi efectuate în weekend?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Curățenie generală, curățenie de întreținere, curățarea mochetelor, a pardoselilor sau a suprafețelor vitrate, în funcție de ce presupune proiectul."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Cât costă curățenia în weekend?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Oferta se stabilește după evaluarea spațiului, a serviciilor, a frecvenței și a resurselor necesare."
                    }
                    }
                    ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "image": "https://i.ibb.co/d05bPW3Z/image-17.jpg",
                      "telephone": "0730 407 322",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                        "addressLocality": "București",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      }  
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <MKBox pt={4} pb={2}>
                    <GoogleTrustIndex />
                </MKBox>
                <ArticleContent />
            </Card>
        </>
    );
}

export default CuratenieInWeekend;
